import { MessageService } from '@app/shared/services';
import { StudentService } from '@app/admin/services';
import { AccountService } from '@app/auth/services';
import pageSettings from '@helpers/page-settings';
import { Student } from '@app/admin/model';
import { Injectable } from '@angular/core';
import { User } from '@app/auth/model';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InitStudentService {
  pageSettings = pageSettings;
  returnUrl: string;
  public student: Student;
  public user: User = new User();
  public checkUpdateOk = true;
  private userRoles: Array<any>;

  constructor(
    private messageService: MessageService,
    private accountService: AccountService,
    private studentService: StudentService
  ) {
    this.setConfigPage();
    this.user = this.accountService.getUserData();
    this.userRoles = this.accountService.getRolesByUser();
  }

  async setConfigPage(
    update: boolean = false,
    showHubSpot: boolean = true,
    pageEmpty: boolean = false
  ) {
    this.pageSettings.pageEmpty = pageEmpty;
    this.pageSettings.pageSidebar = !update;
    this.pageSettings.pageWithoutFooter = true;
    this.pageSettings.pageContentBrandGradient = false;
    this.pageSettings.pageContentBgTransparent = false;

    this.user = this.accountService.getUserData();

    if (this.user != null) {
      this.getStudentByUser();
    }

    this.messageService.displayHubSpot(showHubSpot);
  }

  getStudentUser(): any {
    this.user = this.accountService.getUserData();
    return this.studentService.getByUserId(this.user.id);
  }

  async getStudentByUser() {
    this.user = this.accountService.getUserData();
    this.studentService
      .getByUserId(this.user.id)
      .pipe(first())
      .subscribe(
        (response: Student) => {
          this.student = response;
        },
        (error: any) => {
          //console.log(error);
          return null;
        }
      );
  }

  public CheckHavePermission(role: any): boolean {
    if (this.userRoles) {
      if (role && this.userRoles != null && this.userRoles.length > 0) {
        return this.userRoles.some((x) => x.keyDefault == role);
      } else {
        return false;
      }
    } else {
      this.userRoles = this.accountService.getRolesByUser();
    }
  }
}
